import React from "react";
import { useTranslation } from "react-i18next";

function IconExport() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M8 1v8M5 6l3 3 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 11v2a1 1 0 001 1h10a1 1 0 001-1v-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

function IconImport() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M8 9V1M5 4l3-3 3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 11v2a1 1 0 001 1h10a1 1 0 001-1v-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

// Script/document glyph — used for the locked-down provisioning-script download.
function IconScript() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M4 1.5h5L12.5 5v9.5a1 1 0 01-1 1h-7a1 1 0 01-1-1v-12a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
      <path d="M8.5 1.5V5h3.5M5.5 8.5h5M5.5 11h5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default function DatabaseHeader({
  selectedDatabaseLabel,
  indexesCount,
  hasSelection,
  isProvisioningPending,
  onActivateClick,
  onDownloadScript,
  onAddIndexClick,
  propertiesOpen,
  onPropertiesClick,
  onExportConfig,
  onImportConfig,
  importFileRef,
}) {
  const { t } = useTranslation();

  return (
    <div className="indexes-detail-header">
      <div>
        <div className="indexes-detail-label">
          {t("admin.selectedDatabaseLabel", {
            defaultValue: "Selected database",
          })}
        </div>
        <div className="indexes-detail-name">
          {hasSelection
            ? selectedDatabaseLabel
            : t("admin.selectPlaceholder", {
                defaultValue: "Choose a database to manage indexes.",
              })}
        </div>
      </div>
      <div className="indexes-detail-header-right">
        {hasSelection && (
          <>
            {isProvisioningPending && (
              <span
                className="chip-btn"
                style={{ background: "#fff7ed", color: "#b45309", border: "1px solid #fed7aa", cursor: "default" }}
                title={t("admin.provisioningPendingHint", {
                  defaultValue: "This document base awaits DBA provisioning of its physical table.",
                })}
              >
                {t("admin.provisioningPendingBadge", { defaultValue: "Awaiting DB provisioning" })}
              </span>
            )}
            <div className="indexes-detail-count">
              {t("admin.indexCount", {
                count: indexesCount,
                defaultValue: `${indexesCount} index(es)`,
              })}
            </div>
            <div className="indexes-detail-actions">
              {onActivateClick && (
                <button
                  type="button"
                  className="chip-btn indexes-add-index-chip"
                  onClick={onActivateClick}
                  title={t("admin.activateDatabase", { defaultValue: "Verify the provisioned table and activate this base" })}
                >
                  {t("admin.activateDatabase", { defaultValue: "Activate" })}
                </button>
              )}
              {onDownloadScript && (
                <button
                  type="button"
                  className="chip-btn chip-btn--icon"
                  onClick={onDownloadScript}
                  title={t("admin.downloadProvisioningScript", { defaultValue: "Download provisioning script (.sql)" })}
                >
                  <IconScript />
                </button>
              )}
              {onPropertiesClick && (
                <button
                  type="button"
                  className={`chip-btn indexes-add-index-chip${propertiesOpen ? " indexes-props-chip--active" : ""}`}
                  onClick={onPropertiesClick}
                  title={t("admin.propertiesButton", { defaultValue: "Database properties" })}
                >
                  {t("admin.propertiesButton", { defaultValue: "Properties" })}
                </button>
              )}
              {onExportConfig && (
                <button
                  type="button"
                  className="chip-btn chip-btn--icon"
                  onClick={onExportConfig}
                  title={t("admin.exportConfig", { defaultValue: "Export Config" })}
                >
                  <IconExport />
                </button>
              )}
              {onImportConfig && (
                <>
                  <button
                    type="button"
                    className="chip-btn chip-btn--icon"
                    onClick={() => importFileRef?.current?.click()}
                    title={t("admin.importConfig", { defaultValue: "Import Config" })}
                  >
                    <IconImport />
                  </button>
                  <input
                    ref={importFileRef}
                    type="file"
                    accept=".json,.depconfig.json"
                    style={{ display: "none" }}
                    onChange={onImportConfig}
                  />
                </>
              )}
              {onAddIndexClick && (
                <button
                  type="button"
                  className="chip-btn indexes-add-index-chip"
                  onClick={onAddIndexClick}
                >
                  {t("admin.addIndexButton", { defaultValue: "Add Index" })}
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
